import { useEffect, useState } from "react";
import { getDecodedToken } from "../auth";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

function Settings() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const decodedData = getDecodedToken();
    if (decodedData) {
      setUser(decodedData);
    }
  }, []);

  useEffect(() => {
    if (user) {
      setFormData((prev) => ({ ...prev, email: user.email }));
    }
  }, [user]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const [formData, setFormData] = useState({
    email: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      toast.error("New & Confirm Password do not Match", {
        position: "top-right",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://7otfgyv0ke.execute-api.ap-south-1.amazonaws.com/prod/update_user_password_mongodb",
        {
          email: user.email,
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
        }
      );

      const res = response.data?.["body-json"];
      const statusCode = res?.statusCode;
      const message = res?.body ? JSON.parse(res.body).message : null;

      if (statusCode === 200) {
        toast.success("Password Updated", {
          position: "top-right",
        });

        setFormData({
          email: user.email,
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        toast.error(message || "Failed Updating Password", {
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error("Please Try Again", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  const getPasswordStrength = (password) => {
    if (!password) return "";

    const lengthCriteria = password.length >= 8;
    const upperCase = /[A-Z]/.test(password);
    const number = /\d/.test(password);
    const specialChar = /[!@#$%^&*]/.test(password);

    const passed = [lengthCriteria, upperCase, number, specialChar].filter(
      Boolean
    ).length;

    if (passed <= 1) return "Weak";
    if (passed === 2 || passed === 3) return "Medium";
    return "Strong";
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div>
            <div class="container-fluid my-3 px-3">
              <div class="row g-2">
                <div className="col-lg-8">
                  <div className="p-5 bg-white rounded-4">
                    <div className="card-header">
                      <h4 className="mb-0 lh-1">A/C Settings</h4>
                      <p className="mb-0 lh-1">Edit your account settings</p>
                    </div>
                    <div className="card-body mt-3">
                      <h5 className="mb-0 lh-1">Email Address</h5>
                      <p className="lh-1 mb-1">
                        Your current email address is{" "}
                        <span className="text-success">{user?.email}</span>
                      </p>
                      <form className="row needs-validation" noValidate="">
                        <div className="mb-3 col-lg-6 col-md-12 col-12">
                          <label
                            className="form-label"
                            htmlFor="securityNewEmail"
                          >
                            New email address
                          </label>
                          <input
                            id="securityNewEmail"
                            type="email"
                            name="securityNewEmail"
                            className="form-control"
                            placeholder="Enter Email Address"
                            required
                          />
                          <div className="invalid-feedback">
                            Please Enter email address
                          </div>
                          <button
                            type="submit"
                            className="btn btn-primary fs-5 mt-2 px-5"
                          >
                            Update Email ID
                          </button>
                        </div>
                      </form>
                      <hr className="my-3" />
                      <div className="pt-1">
                        <h5 className="mb-0 lh-1">Change Password</h5>
                        <p className="lh-sm mb-0">
                          Keep your account safe and secure by updating your
                          password regularly
                        </p>
                        <p className="mb-1 lh-1">
                          Can't remember your current password?{" "}
                          <a href="#">Reset password via email</a>.
                        </p>
                        <form onSubmit={handleSubmit}>
                          <div className="col-lg-6 col-md-12 col-12">
                            <div className="mb-2">
                              <label
                                className="form-label"
                                htmlFor="securityCurrentPass"
                              >
                                Current Password
                              </label>
                              <input
                                type="password"
                                name="oldPassword"
                                className="form-control"
                                value={formData.oldPassword}
                                onChange={handleChange}
                                required
                                placeholder="Enter Current Password"
                              />
                            </div>
                            <div className="mb-2">
                              <label
                                className="form-label"
                                htmlFor="securityNewPass"
                              >
                                New Password
                              </label>
                              <input
                                type="password"
                                name="newPassword"
                                className="form-control mb-2"
                                value={formData.newPassword}
                                onChange={handleChange}
                                required
                                placeholder="Enter New Password"
                              />
                            </div>
                            <div className="mb-2">
                              <label
                                className="form-label"
                                htmlFor="securityConfirmPass"
                              >
                                Confirm New Password
                              </label>
                              <input
                                type="password"
                                name="confirmPassword"
                                className="form-control mb-2"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                required
                                placeholder="Enter Confirm New Password"
                              />
                            </div>
                            <button
                              type="submit"
                              className="btn btn-primary fs-5 px-5"
                              disabled={loading}
                            >
                              {loading ? (
                                <div
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                ></div>
                              ) : (
                                "Update Password"
                              )}
                            </button>
                            <div className="col-6" />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div class="p-5 bg-white rounded-4">
                    <div className="d-flex flex-column align-items-center">
                      <div>
                        <img
                          src={`/assets/images/users/${user?.name}.jpg`}
                          className="object-fit-cover rounded-3 me-2"
                          width="90"
                          height="90"
                          alt="Image"
                        />
                        <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                            className="w-100 position-absolute p-2 rounded-4"
                            alt="QR"
                          />
                        </div>
                      </div>
                      <div className="mt-3 text-center">
                        <p className="m-0">{user?.userId}</p>
                        <h3 class="m-0 fs-4 lh-sm text-uppercase">
                          {user?.name}
                        </h3>
                        <p className="m-0 text-dark mt-2">{user?.email}</p>
                        <p className="m-0 text-dark lh-1">{user?.phone}</p>

                        <div className="mt-3">
                          <span
                            onClick={handleLogout}
                            class="btn btn-danger btn-sm px-4 rounded-3 fw-normal"
                          >
                            <i className="bi bi-power me-1"></i> Logout
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="bg-danger-soft rounded-4 px-4 py-3 mt-4 d-flex align-items-center">
                      <i className="bi bi-clock me-3 fs-4"></i>
                      <p className="m-0 lh-1 text-dark text-center">
                        Activity Logs &mdash; View a real-time log of your
                        actions and system events.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default Settings;
